import { Directive, ElementRef, AfterContentInit } from '@angular/core';

@Directive({
  selector: 'input[appAutoFocus]'
})
export class AutofocusDirective implements AfterContentInit {

  constructor(
    private el: ElementRef<HTMLInputElement>
  ) { }

  ngAfterContentInit() {
    setTimeout(() => {
      this.el.nativeElement.focus();
    }, 0);
  }

}
